module.exports = __webpack_public_path__ + "static/media/Main2.d0c3642a.png";